import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../static/css/HomeAffiliatePill.css';

class HomeAffiliatePill extends Component {
    render() {
        const { user } = this.props;
        if (!user || !user.is_affiliate) return null;

        const tier = user.affiliate_tier === 'founding' ? 'founding' : 'regular';
        const isFounding = tier === 'founding';
        const className = `home-affiliate-pill home-affiliate-pill-${tier}`;

        return (
            <div className="home-affiliate-pill-wrapper">
                <Link to="/affiliate" className={className} style={{fontFamily: "'Chelsea Market', cursive"}}>
                    {isFounding ? (
                        <>
                            <span className="home-affiliate-pill-spark">✨</span>
                            <span className="home-affiliate-pill-text">View Founding Affiliate</span>
                            <span className="home-affiliate-pill-spark">✨</span>
                        </>
                    ) : (
                        <span className="home-affiliate-pill-text">View Affiliate Dashboard</span>
                    )}
                </Link>
            </div>
        );
    }
}

export default HomeAffiliatePill;
